import {
  createUploadReducerWithName,
  getActionCreatorsWithName,
} from './upload';
import { prepareMedicalPayload } from '../../helpers/claims/medicalClaim';
import { submitClaimForm } from '../../api/claimApi';

const uploadReducer = createUploadReducerWithName('medicalClaim');

const UPDATE_MEDICAL_FORM = 'efes/medicalClaim/UPDATE_MEDICAL_FORM';
const CLEAR_MEDICAL_FORM = 'efes/medicalClaim/CLEAR_MEDICAL_FORM';
const SET_LANGUAGE = 'efes/medicalClaim/SET_LANGUAGE';
const SUBMIT_FORM = 'efes/medicalClaim/SUBMIT_FORM';
const SUBMIT_FORM_SUCCESS = 'efes/medicalClaim/SUBMIT_FORM_SUCCESS';
const SUBMIT_FORM_ERROR = 'efes/medicalClaim/SUBMIT_FORM_ERROR';

const initialState = {
  personalData: null,
  accidentInfo: null,
  compensation: null,
  attachments: uploadReducer(),
  conclusion: null,
  isSubmitting: false,
  submitSuccess: false,
  error: null,
  language: undefined,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPDATE_MEDICAL_FORM:
      return {
        ...state,
        [action.section.name]: {
          ...state[action.section.name],
          ...action.section.data,
        },
      };

    case SET_LANGUAGE:
      return {
        ...state,
        language: action.language,
      };

    case SUBMIT_FORM:
      return {
        ...state,
        isSubmitting: true,
      };
    case SUBMIT_FORM_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        submitSuccess: true,
      };
    case SUBMIT_FORM_ERROR:
      return {
        ...state,
        isSubmitting: false,
        error: action.error,
      };
    case CLEAR_MEDICAL_FORM:
      return {
        ...initialState,
        language: state.language,
      };
    default:
      return {
        ...state,
        attachments: uploadReducer(state.attachments, action),
      };
  }
}

export const updateMedicalForm = (section) => ({
  type: UPDATE_MEDICAL_FORM,
  section,
});

export const setLanguage = (language) => ({
  type: SET_LANGUAGE,
  language,
});

export const clearMedicalForm = () => ({
  type: CLEAR_MEDICAL_FORM,
});

export const submitForm = () => (dispatch, getState) => {
  const formData = getState().medicalClaim;
  const payload = prepareMedicalPayload(formData);

  return dispatch({
    actions: [
      { type: SUBMIT_FORM },
      { type: SUBMIT_FORM_SUCCESS },
      { type: SUBMIT_FORM_ERROR, showError: true },
    ],
    promise: submitClaimForm('medical-claim', payload),
  });
};

export const uploadActions = getActionCreatorsWithName('medicalClaim');
